import { ROUTES } from 'constants/routes';
import { isParashariLearnPath } from 'shared/lib/bhriguContextStack';
import { isSchoolLearnPath } from 'utils/learnerNavActive';

/**
 * Platform floating AskGuru bubble (AppLayout).
 *
 * Visible only on school learn routes (respective school guide).
 * Parashari learn uses PageFeedbackBubble inside ParashariShell instead.
 * Dashboard, settings, batches, catalog, community, etc. do not show the bubble -
 * anytime chat goes through the dedicated AskGuru page.
 */
export function shouldShowPlatformBhriguBubble({
  pathname,
  isFeatureVisible,
  isAdmin,
  hasEnrolledCourseAccess = false,
}: {
  pathname: string;
  isFeatureVisible: (key: string) => boolean;
  isAdmin: boolean;
  hasEnrolledCourseAccess?: boolean;
}): boolean {
  if (pathname.startsWith(ROUTES.ADMIN)) return false;
  if (pathname === ROUTES.AI_TUTOR || pathname.startsWith('/ai/')) return false;
  if (pathname === ROUTES.MARKETING_ASK_GURU) return false;

  // Parashari learn shell mounts its own bubble with lesson page context.
  if (isParashariLearnPath(pathname)) return false;

  // Only school learn surfaces get the floating guide bubble.
  if (!isSchoolLearnPath(pathname)) return false;

  const flagOn = isAdmin || isFeatureVisible('askBhrigu');
  if (!flagOn && !hasEnrolledCourseAccess) return false;

  return true;
}
